// Watch for when is-external class is added
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      const link = mutation.target;
      if (link.classList.contains('is-external') && !link.classList.contains('button')) {
        wrapLastWord(link);
      }
    }
  });
});

// Start observing all links
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a').forEach(link => {
    observer.observe(link, { attributes: true });
  });
});

function wrapLastWord(link) {
  // Only run once per link
  if (link.dataset.wrapped) return;
  link.dataset.wrapped = 'true';
  
  console.log("Wrapping:", link.textContent.substring(0, 30));
  
  const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
  let lastTextNode = null;
  
  while (walker.nextNode()) {
    if (walker.currentNode.textContent.trim()) {
      lastTextNode = walker.currentNode;
    }
  }
  
  if (lastTextNode) {
    const text = lastTextNode.textContent;
    const words = text.trim().split(/\s+/);
    
    if (words.length > 0) {
      const lastWord = words[words.length - 1];
      const beforeLastWord = text.substring(0, text.lastIndexOf(lastWord));
      
      // Create wrapper span with nowrap AND a class
      const span = document.createElement('span');
      span.className = 'external-link-wrapper';
      span.style.whiteSpace = 'nowrap';
      span.style.textDecoration = 'inherit';
      span.textContent = lastWord;
      
      // Create the icon element with just a class
      const icon = document.createElement('span');
      icon.className = 'external-icon';
      
      span.appendChild(icon);
      
      lastTextNode.textContent = beforeLastWord;
      lastTextNode.parentNode.appendChild(span);
    }
  }
}